import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class ProductFilterData {
    products: Array<DropdownOptionIntegerId>;
    platforms: Array<DropdownOptionIntegerId>;
    leadSMEs: Array<DropdownOptionIntegerId>;
    services: Array<DropdownOptionIntegerId>;
}
